import { Button } from "@nextui-org/react";
import { getDownloadURL, ref } from "firebase/storage";
import { useEffect, useState } from "react"
import { AiOutlineLeft, AiOutlineRight } from "react-icons/ai";
import { Document, Page, Thumbnail } from "react-pdf";
import { useStorage } from "reactfire";

export const PDFViewer: React.FC<{ filePath: string }> = ({ filePath }) => {

    const [pageNumber, setPageNumber] = useState<number>(0);
    const [numPages, setNumPages] = useState<number>(0);
    const [pdfFile, setPdfFile] = useState<string>();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<string>("");
    const storage = useStorage();
        
    function onDocumentLoadSuccess({ numPages }: { numPages: number }): void {
        setNumPages(numPages);
        setPageNumber(1);
        setIsLoading(false);
        setError("");
    }
    useEffect(() => {
        const loadPDF = async () => {
          try {
            if (filePath === '' || !filePath) return;
    
            console.log('Loading file ' + filePath)
    
            setIsLoading(true);
            setError("");
    
            // Get the file URL from Firebase Storage
            const url = await getDownloadURL(ref(storage, filePath));
    
            console.log('Loading file downloadURL: ' + url)
    
            setPdfFile(url);
          } catch (err: any) {
            setError(err.message || "An error occurred");
          } finally {
            setIsLoading(false);
          }
        };
    
        loadPDF();
      }, [filePath, storage]);
    
    return (
        error ? (<div className="flex justify-center items-center">{error}</div>) :
            (<>
                {isLoading && <div className="flex justify-center items-center">Loading...</div>}
                <div className="flex justify-center items-center mb-2">
                    <div className="flex flex-row items-center gap-4">
                        {pageNumber > (1 || numPages) &&
                            <Button variant="ghost" size="sm"
                                onPress={() => setPageNumber((prev) => (prev - 1))}
                            ><AiOutlineLeft /></Button>
                        }
                        <div className="text">Page {pageNumber} of {numPages}</div>
                        {pageNumber < (numPages || 0) &&
                            <Button variant="ghost" size="sm"
                                disabled={pageNumber >= (numPages || 0)}
                                onPress={() => setPageNumber((prev) => (prev + 1))}><AiOutlineRight /></Button>
                        }
                    </div>
                </div>
                <Document file={pdfFile} className="border-1" onLoadSuccess={onDocumentLoadSuccess}>
                    <Thumbnail pageNumber={pageNumber} width={700} />
                </Document>
            </>)
    )
}